import { cx } from 'class-variance-authority'
import { ScrollArea } from '@skop-app/lib-front'
import { DynamicIcon } from '@/components/atoms/DynamicIcon'
import type { DynamicIconName } from '@/components/atoms/DynamicIcon'

export type ProductAttributesProps = {
  attributes: {
    key: string
    name: string
    items: {
      name: string
      title: string
      icon?: DynamicIconName
    }[]
    type: 'list' | 'text'
  }
  className?: string
}

export const ProductAttributes = ({
  attributes,
  className,
}: ProductAttributesProps) => (
  <div className={cx('flex flex-col gap-2.5', className)}>
    <p className="group relative flex w-full items-center justify-between text-left text-sm font-medium text-slate-800">
      {attributes?.name}
    </p>
    <ScrollArea className="max-h-52">
      <ul
        className={cx(
          attributes?.type !== 'list'
            ? 'pl-0'
            : 'list-inside list-disc marker:text-slate-300',
          'flex flex-col gap-1.5 overflow-y-auto pb-6',
        )}
      >
        {attributes?.items.map((item) => (
          <li className="relative flex items-center gap-2" key={item.name}>
            {item.icon && (
              <DynamicIcon
                weight="duotone"
                name={item.icon}
                className="absolute left-0 top-1 size-4"
              />
            )}
            <p className="pl-6">
              <span className="text-sm font-medium">{item.name}</span>
              <span className="text-sm text-zinc-500">: {item.title}</span>
            </p>
          </li>
        ))}
      </ul>
    </ScrollArea>
  </div>
)
